import { create } from 'zustand'

import { useMainState } from '@core/main-state'
import { authorKeys } from '@pages/author/author-api'
import { useQueryClient } from '@tanstack/react-query'

import { keys as adminKeys } from './admin-api'
import type { AdminView } from './admin-views'

export type State = {
  open: boolean
  selectedCustomerId: string
  loading: boolean
  view: AdminView
}

export const initialState: State = {
  loading: false,
  open: false,
  selectedCustomerId: '',
  view: 'SWITCH_CUSTOMER',
}

type Actions = {
  setState: (partial: Partial<State>) => void
  reset: () => void
}

export const useAdminSettingsStore = create<State & Actions>((set) => ({
  ...initialState,
  setState: (partial) => set(partial),
  reset: () => set(initialState),
}))

export const useAdminSettings = () => {
  const queryClient = useQueryClient()
  const [user, customer] = useMainState((state) => [state.user, state.customer])
  const state = useAdminSettingsStore()

  const handleClose = () => {
    useAdminSettingsStore.getState().setState({ open: false })

    queryClient.invalidateQueries({ queryKey: authorKeys.aiModelList })
    queryClient.invalidateQueries({ queryKey: adminKeys.listCustomers })
  }

  return {
    state,
    setState: useAdminSettingsStore.getState().setState,
    user,
    customer,
    handleClose,
  }
}

export type AdminSettings = ReturnType<typeof useAdminSettings>
